import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleDfpV2Component } from './google-dfp-v2/google-dfp-v2.component';
import { SitebarAdComponent } from './sitebar-ad/sitebar-ad.component';
import { UnderstitialAdComponent } from './understitial-ad/understitial-ad.component';
import { StickyAdComponent } from './sticky-ad/sticky-ad.component';
import { WeatherAdComponent } from './weather-ad/weather-ad.component';
import {MatIconModule} from "@angular/material/icon";

@NgModule({
  declarations: [
    GoogleDfpV2Component,
    SitebarAdComponent,
    UnderstitialAdComponent,
    StickyAdComponent,
    WeatherAdComponent,
  ],
  imports: [CommonModule, MatIconModule],
  exports: [GoogleDfpV2Component],
})
export class AngularTtComWwwFeatureDfpComponentModule {}
